jQuery(function($) {

    // get link from image
    // @ts-ignore
    for (let block of $('.ultp-block-content-wrap')){
        const block$ = $(block);
        const imageLink$ = block$.find('.ultp-block-image a');
        const link = imageLink$.attr('href');
        if (link){
            block$.find('.ultp-category-in a').attr('href', link);
        }
    }
});
